import axios from "axios";
import config from '../../config';
import {getFingerprintJS} from '../fingerprint';
import getUUID from '../canvasid';
import JSEncrypt from 'jsencrypt';

const shouldEncryptParams = [
    'password',
    'username',
    'uid',
    'userid',
    'email',
    'phoneNum'
];

// RSA公钥 
const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCMgrwaFraNYXHqN+XUOWFhgb48
skjkXPbMZqVS7r85GuFQmj91DDh1fjDUNU1KV+wNv4RxrBdLVE485OgAy5RDCMu9
9VA3FvxvNdr1eJR3PlRvcjyvPrvfnA3V8sReUCRB9KO4pb6b02IFI1qP5kD/VLE9
spfpT2J0hR8BAjAxMQIDAQAB
-----END PUBLIC KEY-----`;

// 过期时间戳(时长)
const EXPIRY_DURATION_MS = 10 * 60 * 1000; // 10分钟

// 加密函数
function encryptParams(data) {
    if (!data || typeof data !== 'object') {
        return data;
    }
    
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(RSA_PUBLIC_KEY);
    
    const result = { ...data };
    const encryptedFields = [];
    
    for (const key of shouldEncryptParams) {
        if (result[key] !== undefined && result[key] !== null && result[key] !== '') {
            // 先给需要加密的数据加上有效时间戳
            let willEncryptString = (Date.now() + EXPIRY_DURATION_MS) + '_t_' + String(result[key]);
            const encrypted = encrypt.encrypt(willEncryptString);
            if (encrypted) {
                result[key] = encrypted;
                encryptedFields.push(key);
            }
        }
    }
    
    // 如果有字段被加密，添加加密标识告诉后端
    if (encryptedFields.length > 0) {
        result._encrypted_fields = encryptedFields;
    }
    
    return result;
}

export default new (class {
    constructor(axiosOptions) {
        this.axiosOptions = axiosOptions;
        let _headers = {};
        if (axiosOptions.isFormData) {
            _headers = {
                "Content-Type": "multipart/form-data"
            }
        };
        this.axios = axios.create({
            baseURL: axiosOptions.baseURL,
            timeout: axiosOptions.timeout,
            headers: _headers,
            withCredentials: true,
        });
        this.interceptors(this.axios);
    };
    async request(config, url, isFormData = false) {
        let sendConfig = config;
        if (config.method === 'post') {
            sendConfig.data.cuid = await getFingerprintJS() || ''
            sendConfig.data.cvid = getUUID(location.href) || ''
        } else {
            sendConfig.params.cuid = await getFingerprintJS() || ''
            sendConfig.params.cvid = getUUID(location.href) || ''
        }
        sendConfig.withCredentials = true;
        let instance;
        let _headers = {};
        if (url) {
            if (isFormData) {
                _headers = {
                    "Content-Type": "multipart/form-data"
                }
            };
            instance =  axios.create({
                baseURL: url,
                timeout: this.axiosOptions.timeout,
                headers: _headers
            }); 
        } else {
            instance = this.axios;
        }
        this.interceptors(instance);
        return new Promise((resolve, reject) => {
        instance.request(sendConfig).then(res => {
            resolve(res.data);
        }, err => {
            reject(err);
        })
        });
    };
    interceptors(axios) {
        // 添加请求拦截器
        axios.interceptors.request.use(function (config) {
        // 在发送请求之前做些什么
        // 对POST请求的参数进行加密
        if (config.method?.toLowerCase() === 'post' && config.data && config.headers?.['Content-Type'] !== 'multipart/form-data') {
            config.data = encryptParams(config.data);
        }
        return config;
        }, function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
        });

        // 添加响应拦截器
        axios.interceptors.response.use(function (response) {
        // 对响应数据做点什么
        return response;
        }, function (error) {
        // 对响应错误做点什么
        return Promise.reject(error);
        });
    }
})(config.apiConfig);